var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoTooltip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9036 15.288C12.9036 14.712 13.0316 14.2373 13.2876 13.864C13.5542 13.48 13.9382 13.064 14.4396 12.616C14.8236 12.2747 15.1062 11.9813 15.2876 11.736C15.4796 11.48 15.5756 11.192 15.5756 10.872C15.5756 10.424 15.3942 10.0613 15.0316 9.784C14.6689 9.50667 14.1836 9.368 13.5756 9.368C12.4236 9.368 11.5542 9.77867 10.9676 10.6L9.41556 9.592C9.87423 8.96267 10.4662 8.48267 11.1916 8.152C11.9169 7.81067 12.7702 7.64 13.7516 7.64C14.9462 7.64 15.8956 7.90133 16.5996 8.424C17.3142 8.936 17.6716 9.64533 17.6716 10.552C17.6716 10.9893 17.5969 11.3733 17.4476 11.704C17.3089 12.0347 17.1382 12.3173 16.9356 12.552C16.7329 12.776 16.4662 13.0373 16.1356 13.336C15.7302 13.6987 15.4262 14.0187 15.2236 14.296C15.0316 14.5733 14.9356 14.904 14.9356 15.288H12.9036ZM13.9276 19.112C13.5542 19.112 13.2449 18.9947 12.9996 18.76C12.7649 18.5147 12.6476 18.216 12.6476 17.864C12.6476 17.512 12.7649 17.2187 12.9996 16.984C13.2449 16.7493 13.5542 16.632 13.9276 16.632C14.2902 16.632 14.5889 16.7493 14.8236 16.984C15.0689 17.2187 15.1916 17.512 15.1916 17.864C15.1916 18.216 15.0689 18.5147 14.8236 18.76C14.5889 18.9947 14.2902 19.112 13.9276 19.112Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13,
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoTooltip);
export default __webpack_public_path__ + "static/media/info-tooltip.95feeefb80503383aede93deb1543a70.svg";
export { ForwardRef as ReactComponent };